import { render, staticRenderFns } from "./upInput.vue?vue&type=template&id=25dac0bb&scoped=true"
import script from "./upInput.vue?vue&type=script&lang=js"
export * from "./upInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dac0bb",
  null
  
)

export default component.exports